/**
 * We need to combine the reducers from other files into a root reducer here
 *
 * We also need to re-export all the actions exported by the other slice reducers
 */
import { configureStore } from '@reduxjs/toolkit';
import modalHandlerReducer from './modalHandlerReducer';
import zipCodeReducer from './zipCodeReducer';
import filtersReducer from './filtersReducer';
import { IS_PROD_ENV } from '../constants/environment';
import offersReducer from './offersReducer';
import dealerContextReducer from './dealerContextReducer';
import configFiltersReducer from './configFiltersReducer';

export const store = configureStore({
  reducer: {
    modalState: modalHandlerReducer,
    filters: filtersReducer,
    zipCodeState: zipCodeReducer,
    offersState: offersReducer,
    dealerContext: dealerContextReducer,
    configFilters: configFiltersReducer,
  },
  devTools: !IS_PROD_ENV,
});

export type RootState = ReturnType<typeof store.getState>;
